import { createSlice } from "@reduxjs/toolkit";

export const validatePromoCodeSlice = createSlice({
  name: "validatePromoCode",
  initialState: {
    data: null,
    loading: false,
    error: { error: false, message: "" },
  },
  reducers: {
    setValidatePromoCodeData: (state, action) => {
      state.data = action.payload;
      state.error = { error: false, message: "" };
    },
    setValidatePromoCodeLoading: (state, action) => {
      state.loading = action.payload;
    },
    setValidatePromoCodeError: (state, action) => {
      state.error = action.payload;
      state.data = null;
    },
  },
});

export const {
  setValidatePromoCodeData,
  setValidatePromoCodeLoading,
  setValidatePromoCodeError,
} = validatePromoCodeSlice.actions;

export default validatePromoCodeSlice.reducer;
